var map = {
	"./Central-mobile.jpg": 1460,
	"./Mandurah-mobile.jpg": 1461,
	"./North-mobile.jpg": 1462,
	"./South-mobile.jpg": 1463,
	"./default-mobile.jpg": 1464
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1459;